import _ from 'underscore';
import { queryify } from '@bingads-webui/url-util';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import { getProductScopeData } from '@bingads-webui-campaign-react/product-services';

export function getProductData({
  cid,
  aid,
  uid,
  campaignId,
}) {
  const url = queryify('/Campaign/NewCampaign/GetProductScope', {
    cid,
    aid,
    uid,
    campaignId,
    salesCountry: 'US',
    storeTypes: 'placeholder',
  });

  return jsdata.Product.find('MetaData', {
    url,
    adapter: 'legacy',
    bypassCache: true,
    cacheResponse: false,
  });
}

export const getProductScopeFromOData = (campaignId, serverContext) => {
  const options = {
    dataName: 'MetaData',
    bypassCache: true,
    cacheResponse: false,
    campaignId,
    getCampaignCriterions: true,
    getCampaignCriterionsOnly: true,
  };

  const p = getProductScopeData(null, serverContext, options).then((data) => {
    if (data && !_.isEmpty(data) && _.isArray(data)) {
      return _.first(data);
    }

    return {
      CampaignCriterionsData: {
        Criterion: {
          ProductConditions: [{}],
        },
      },
    };
  });

  return p;
};
